import {createPopupCloudHtmlRequester, renderPopupCloudErrorHtml} from "./popup-render-cloud";

function toPositiveInteger(value) {
    return Number.parseInt(value, 10) || 0;
}

function toFirebaseId(value) {
    const firebaseId = String(value || '').trim().toLowerCase();
    return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/.test(firebaseId)
        ? firebaseId
        : '';
}

export const requestSupportTicketPopupCloudHtml = createPopupCloudHtmlRequester({
    authAction: 'wl_get_support_ticket_popup_cloud_auth',
    authMode: 'fresh',
    storageKey: 'support_ticket_popup',
    label: 'Support ticket popup',
    buildCloudPayload(data = {}) {
        return {
            post_id: toPositiveInteger(data.post_id),
            firebase_id: toFirebaseId(data.firebase_id),
            order_id: toPositiveInteger(data.order_id),
            user_id: toPositiveInteger(data.user_id),
            support_ticket_firebase_ids: Array.isArray(data.support_ticket_firebase_ids)
                ? data.support_ticket_firebase_ids.map(toFirebaseId).filter(Boolean)
                : [],
        };
    },
});

export function renderSupportTicketPopupCloudErrorHtml(error = null) {
    return renderPopupCloudErrorHtml(error?.message);
}
